import Icon, { IconType } from "@components/ui/Icon";
import React, { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const Divider = () => {
  return (
    <div className="border-b border-gray-200 opacity-60 my-3 text-xs -mt-1">
      &nbsp;
    </div>
  );
};

interface ItemProps {
  icon: IconType;
  title: string;
  children?: ReactNode;
}

const Item: FC<ItemProps> = ({ icon, title, children }) => {
  return (
    <>
      <div className="flex items-center">
        <div className="md:ml-2 mr-4">
          <Icon icon={icon} size="sm" />
        </div>
        <div>
          <p className="font-semibold text-md">{title}</p>
          <p className="text-gray-500 text-base truncate-2">{children}</p>
        </div>
      </div>
    </>
  );
};

interface SidebarComponents {
  Divider: typeof Divider;
  Item: typeof Item;
}

const Sidebar: FC<{ className?: string; children: ReactNode }> &
  SidebarComponents = ({ children, className = "" }) => {
  return (
    <div
      className={twMerge(
        `sticky top-4 border border-gray-200 shadow-xl px-4 py-4 rounded-xl`,
        className
      )}
    >
      {children}
    </div>
  );
};

Sidebar.Divider = Divider;
Sidebar.Item = Item;

export default Sidebar;
